import API from '../api/PriceApi'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_GROUPS_REQUEST = 'priceGroup/GET_GROUPS_REQUEST'
const GET_GROUPS_SUCCESS = 'priceGroup/GET_GROUPS_SUCCESS'
const GET_GROUPS_FAILURE = 'priceGroup/GET_GROUPS_FAILURE'

const CREATE_GROUP_REQUEST = 'priceGroup/CREATE_GROUP_REQUEST'
const CREATE_GROUP_SUCCESS = 'priceGroup/CREATE_GROUP_SUCCESS'
const CREATE_GROUP_FAILURE = 'priceGroup/CREATE_GROUP_FAILURE'

const UPDATE_GROUP_REQUEST = 'priceGroup/UPDATE_GROUP_REQUEST'
const UPDATE_GROUP_SUCCESS = 'priceGroup/UPDATE_GROUP_SUCCESS'
const UPDATE_GROUP_FAILURE = 'priceGroup/UPDATE_GROUP_FAILURE'

const DELETE_GROUP_REQUEST = 'priceGroup/DELETE_GROUP_REQUEST'
const DELETE_GROUP_SUCCESS = 'priceGroup/DELETE_GROUP_SUCCESS'
const DELETE_GROUP_FAILURE = 'priceGroup/DELETE_GROUP_FAILURE'

const SET_GROUP_PRICES_REQUEST = 'priceGroup/SET_GROUP_PRICES_REQUEST'
const SET_GROUP_PRICES_SUCCESS = 'priceGroup/SET_GROUP_PRICES_SUCCESS'
const SET_GROUP_PRICES_FAILURE = 'priceGroup/SET_GROUP_PRICES_FAILURE'

const GET_GROUP_PRICES_REQUEST = 'priceGroup/GET_GROUP_PRICES_REQUEST'
const GET_GROUP_PRICES_SUCCESS = 'priceGroup/GET_GROUP_PRICES_SUCCESS'
const GET_GROUP_PRICES_FAILURE = 'priceGroup/GET_GROUP_PRICES_FAILURE'

const TEST_SEND_GROUP_REQUEST = 'priceGroup/TEST_SEND_GROUP_REQUEST'
const TEST_SEND_GROUP_SUCCESS = 'priceGroup/TEST_SEND_GROUP_SUCCESS'
const TEST_SEND_GROUP_FAILURE = 'priceGroup/TEST_SEND_GROUP_FAILURE'

const initialState = {
  isLoading: true,
  isSaving: false,
  isTesting: false,
  isGroupPricesLoading: false,
  error: {},
  groups: [],
  groupPrices: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS_REQUEST:
      return { ...state, isLoading: true }
    case GET_GROUPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        groups: Array.isArray(action.payload) ? action.payload : []
      }
    case GET_GROUPS_FAILURE:
      return { ...state, isLoading: false, error: action.error }
    case CREATE_GROUP_REQUEST:
    case UPDATE_GROUP_REQUEST:
    case DELETE_GROUP_REQUEST:
    case SET_GROUP_PRICES_REQUEST:
      return { ...state, isSaving: true }
    case CREATE_GROUP_SUCCESS:
    case UPDATE_GROUP_SUCCESS:
    case DELETE_GROUP_SUCCESS:
    case SET_GROUP_PRICES_SUCCESS:
      return { ...state, isSaving: false }
    case CREATE_GROUP_FAILURE:
    case UPDATE_GROUP_FAILURE:
    case DELETE_GROUP_FAILURE:
    case SET_GROUP_PRICES_FAILURE:
      return { ...state, isSaving: false, error: action.error }
    case GET_GROUP_PRICES_REQUEST:
      return { ...state, isGroupPricesLoading: true, groupPrices: [] }
    case GET_GROUP_PRICES_SUCCESS:
      return {
        ...state,
        isGroupPricesLoading: false,
        groupPrices: Array.isArray(action.payload) ? action.payload : []
      }
    case GET_GROUP_PRICES_FAILURE:
      return {
        ...state,
        isGroupPricesLoading: false,
        error: action.error
      }
    case TEST_SEND_GROUP_REQUEST:
      return { ...state, isTesting: true }
    case TEST_SEND_GROUP_SUCCESS:
      return { ...state, isTesting: false }
    case TEST_SEND_GROUP_FAILURE:
      return { ...state, isTesting: false, error: action.error }
    default:
      return state
  }
}

export const getGroups = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_GROUPS_REQUEST })
      const response = await API.get(EndPoints.PRICE_GROUP)
      dispatch({
        type: GET_GROUPS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_GROUPS_FAILURE,
        error: err
      })
    }
  }
}

export const createGroup = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_GROUP_REQUEST })
      await API.post(EndPoints.PRICE_GROUP, data)
      dispatch({ type: CREATE_GROUP_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
      return true
    } catch (err) {
      const detail = err && err.response && err.response.data && err.response.data.detail
      message.error(detail || RESPONSE_MESSAGE.FAIL)
      dispatch({ type: CREATE_GROUP_FAILURE, error: err })
      return false
    }
  }
}

export const updateGroup = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_GROUP_REQUEST })
      await API.put(EndPoints.PRICE_GROUP + `/${data.id}`, data)
      dispatch({ type: UPDATE_GROUP_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
      return true
    } catch (err) {
      const detail = err && err.response && err.response.data && err.response.data.detail
      message.error(detail || RESPONSE_MESSAGE.FAIL)
      dispatch({ type: UPDATE_GROUP_FAILURE, error: err })
      return false
    }
  }
}

export const deleteGroup = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_GROUP_REQUEST })
      await API.delete(EndPoints.PRICE_GROUP + `/${id}`)
      dispatch({ type: DELETE_GROUP_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({ type: DELETE_GROUP_FAILURE, error: err })
    }
  }
}

export const setGroupPrices = (groupId, priceIds) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_GROUP_PRICES_REQUEST })
      await API.post(EndPoints.PRICE_GROUP + `/${groupId}/prices`, {
        price_ids: priceIds
      })
      dispatch({ type: SET_GROUP_PRICES_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({ type: SET_GROUP_PRICES_FAILURE, error: err })
    }
  }
}

export const testSendGroup = (groupId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: TEST_SEND_GROUP_REQUEST })
      await API.post(EndPoints.PRICE_GROUP + `/${groupId}/test-send`)
      dispatch({ type: TEST_SEND_GROUP_SUCCESS })
      message.success('ส่ง Discord สำเร็จ')
      return true
    } catch (err) {
      const detail =
        (err && err.response && err.response.data && err.response.data.detail) ||
        RESPONSE_MESSAGE.FAIL
      message.error(detail)
      dispatch({ type: TEST_SEND_GROUP_FAILURE, error: err })
      return false
    }
  }
}

export const getGroupPrices = (groupId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_GROUP_PRICES_REQUEST })
      const response = await API.get(
        EndPoints.PRICE_PUBLIC + `/group/${groupId}`
      )
      const data = Array.isArray(response.data) ? response.data : []
      dispatch({ type: GET_GROUP_PRICES_SUCCESS, payload: data })
      return data
    } catch (err) {
      dispatch({ type: GET_GROUP_PRICES_FAILURE, error: err })
      return []
    }
  }
}
